import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { GetWebhookListDto, SmsSentPeriodType } from 'src/app/core/api/models';
import { PhonebooksService, PrivateNumbersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { PeriodicTypeConfig } from 'src/app/shared/components/periodic-type/periodic-type.component';
import { TextParserIfConditionType } from './../../../../../../../core/api/models/text-parser-if-condition-type';
import { TextParserThenConditionType } from './../../../../../../../core/api/models/text-parser-then-condition-type';
import { DialogService, DialogStatus } from './../../../../../../../core/services/dialog.service';
import { BaseFormPageComponent } from './../../../../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-text-parser-then-condition-modal',
    templateUrl: './text-parser-then-condition-modal.component.html',
    styleUrls: ['./text-parser-then-condition-modal.component.scss'],
    imports: [BaseFormModule]
})
export class TextParserThenConditionModalComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  model: ThenConditionValueDto = {};
  periodicTypeConfig: PeriodicTypeConfig;

  filteredItems: any[] = [];
  phoneBookFilterList: any[] = [];

  @Input() thenConditionType?: TextParserThenConditionType;
  @Input() ifConditionType?: TextParserIfConditionType;
  @Input() thenConditionValue: string;
  @Input() thenConditionTypeEnumValues?: any[];
  @Input() smsSentPeriodTypeEnumValues?: any[];

  privateNumber: any;
  findPrivateNumber: any = {};
  items: any = [];

  //  @Output('thenConditionType') output_thenConditionType = new EventEmitter<TextParserThenConditionType>();

  get TextParserThenConditionType() {
    return TextParserThenConditionType;
  }

  //isShow
  isShowIfConditionValue: boolean = false;
  isShowSmsBody: boolean = false;
  isShowPrivateNumber: boolean = false;
  isShowSenderPhonebook: boolean = false;
  isShowMobileNumber: boolean = false;
  isShowPhonebooks: boolean = false;
  isShowDynamicTemplateId: boolean = false;
  isShowWebhook: boolean = false;
  isShowEmail: boolean = false;
  isShowSentDelayType: boolean = false;

  //#endregion

  constructor(
    private dialogService: DialogService,
    private privateNumbersService: PrivateNumbersService,
    private phonebooksService: PhonebooksService
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.fields = 'pages.textParsers.form.fields.';
      this.convertJsonToObject();
      this.onChangeThenConditionType(this.thenConditionType);

      if (this.isShowPrivateNumber || this.isShowSmsBody) {
        this.loading = true;
        this.getPrivateNumbersApi();
      }
      if (this.isShowPhonebooks) {
        this.loading = true;
        this.getPhonebooksServiceApi();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  initModel() {
    try {
      this.periodicTypeConfig = {
        periodTypeLabel: this.fields + 'sentDelayType',
        periodTextLabel: this.fields + 'sentDelayValue',
        periodTypeControl: this.form?.get(
          'sendDelay.sentDelayType'
        ) as FormControl,
        periodTextControl: this.form?.get(
          'sendDelay.sentDelayValue'
        ) as FormControl,
        periodText: this.model.sentDelayValue,
        periodType: this.model.sentDelayType,
        isTextParser: true,
      };
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // try {
    //   if (changes["ifConditionType"])
    //     this.onChangeThenConditionType(this.thenConditionType)
    //   if (changes["thenConditionValue"] && this.thenConditionValue) {
    //     this.convertJsonToObject();
    //     this.onChangeThenConditionType(this.thenConditionType, true)
    //   }
    // } catch (error) {
    //   this.loggerService.logError(this.tagName, error, EventTypes.services)
    // }
  }

  initForm() {
    this.form = new FormGroup({
      thenConditionType: new FormControl('', Validators.required),
      smsBody: new FormControl(),
      privateNumberId: new FormControl(),
      phonebookId: new FormControl(),
      mobileNumber: new FormControl(),
      matchingDynamicTemplateId: new FormControl(),
      noMatchingDynamicTemplateId: new FormControl(),
      webhookAddress: new FormControl(),
      email: new FormControl('', Validators.email),
      sendDelay: new FormGroup({
        sentDelayValue: new FormControl(),
        sentDelayType: new FormControl(),
      }),
    });
    this.form.disable();
  }

  isValidIfConditionTypeForShowSendSmsFromTemplateType(
    type: TextParserThenConditionType
  ): boolean {
    try {
      if (type != TextParserThenConditionType.SendSmsFromTemplate) {
        this.isShowDynamicTemplateId = false;
        return;
      }

      const msg = 'messages.isValidIfConditionType';
      let result: boolean = true;

      switch (this.ifConditionType) {
        case TextParserIfConditionType.NationalCode:
        case TextParserIfConditionType.EqualToPhonebookField:
        // case TextParserIfConditionType.UseDataBaseTable:
        case TextParserIfConditionType.TokenService:
          // valid
          break;
        default:
          this.isShowDynamicTemplateId = false;
          result = false;
          this.dialogService.openDialog({
            title: 'common.error',
            message: msg,
            status: DialogStatus.error,
          });
          break;
      }

      return result;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#region thenCondition

  onChangeThenConditionType(type: TextParserThenConditionType) {
    try {
      this.thenConditionType = type;

      let isAllowChangeStatus: boolean = true;
      if (type == TextParserThenConditionType.SendSmsFromTemplate)
        isAllowChangeStatus =
          this.isValidIfConditionTypeForShowSendSmsFromTemplateType(type);

      // if (!isAllowChangeStatus)
      //   this.onRemoveThenConditionType();

      // if (!noDeletePreviousValues)
      //   this.hideAllDynamicFormulaInput();

      if (isAllowChangeStatus)
        switch (this.thenConditionType) {
          case TextParserThenConditionType.AddToPhonebook:
            this.isShowPhonebooks = true;
            break;
          case TextParserThenConditionType.DeleteFromPhonebook:
            this.isShowPhonebooks = true;
            break;
          case TextParserThenConditionType.TransferToMobile:
            this.isShowMobileNumber = true;
            this.isShowPrivateNumber = true;
            this.isShowSentDelayType = true;
            break;
          case TextParserThenConditionType.TransferSenderMobileToMobile:
            this.isShowMobileNumber = true;
            this.isShowPrivateNumber = true;
            break;
          case TextParserThenConditionType.TransferToAddress:
            this.isShowWebhook = true;
            break;
          case TextParserThenConditionType.TransferToEmail:
            this.isShowEmail = true;
            break;
          case TextParserThenConditionType.SendSmsToSenderAgent:
            this.isShowSmsBody = true;
            this.isShowSentDelayType = true;
            break;
          case TextParserThenConditionType.SendSmsToPhonebook:
            this.isShowPhonebooks = true;
            this.isShowSmsBody = true;
            this.isShowSentDelayType = true;
            break;
          case TextParserThenConditionType.SendReceivedSmsToPhonebook:
            this.isShowSenderPhonebook = true;
            this.isShowPrivateNumber = true;
            this.isShowSentDelayType = true;
            break;
          case TextParserThenConditionType.SendSmsFromTemplate:
            this.isShowDynamicTemplateId = true;
            break;
          default:
            break;
        }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#endregion

  //#region Json

  onCreateJson(): void {
    this.convertObjectToJson();
  }

  convertObjectToJson() {
    try {
      this.thenConditionValue = JSON.stringify(this.model);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  convertJsonToObject() {
    try {
      this.model = JSON.parse(this.thenConditionValue);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#endregion

  //#region api

  getPrivateNumbersApi() {
    this.privateNumbersService
      .privateNumbersGetUserPrivateNumbersForSend({})
      .pipe(this.basePipeOperators())
      .subscribe((items) => {
        const item = items.data?.find((item) => {
          return item.id == this.model.privateNumberId;
        });
        this.findPrivateNumber = item;
      });
  }

  getPhonebooksServiceApi() {
    this.phonebooksService
      .phonebooksGetPhonebooksListForServices()
      .pipe(this.basePipeOperators())
      .subscribe((items) => {
        items.data?.forEach((el) => {
          if (this.model.phonebookIds.some((a) => a == el.id)) {
            this.filteredItems.push(el);
          }
        });
        this.phoneBookFilterList = this.filteredItems;
      });
  }

  //#endregion

  //#region emit

  //#endregion

  onSelectWebhook(event: GetWebhookListDto) {
    try {
      this.model.webhookId = event.id;
      this.model.webhookAddress = event.url;
      this.onCreateJson();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }
}

export class ThenConditionValueDto {
  privateNumberId?: number;
  phonebookId?: number;
  mobileNumber?: string;
  sentDelayValue?: number;
  sentDelayType?: SmsSentPeriodType;
  smsBody?: string;
  phonebookIds?: number[];
  webhookId?: number;
  webhookAddress?: string;
  email?: string;
  matchingDynamicTemplateId?: number;
  noMatchingDynamicTemplateId?: number;
}
